import Odoo from 'odoo-xmlrpc';
import { OdooConfig } from '../utilities/odoo-config';
//const country='colombia';

export const Login = async (data, call) => {
    const config = await OdooConfig();
    const odoo = new Odoo({
      url: config.host,
      port: config.port,
      db: config.database,
      username: data.user,
      password: data.password,
    });
  
    console.log("Conectando a Odoo...", odoo);
  
    odoo.connect((err, response) => {
      if (err) {
        console.error("Error en la conexión:", err);
        call(false, err);
      } else {
        console.log("Conexión exitosa:", response);
        localStorage.setItem("uid", response);
        setData(odoo, call);
      }
    });
  };
  
  export const setData = (odoo, call) => {
    const args = [[0]]; // Define los argumentos para la llamada a Odoo
    const params = {
      model: "club.user.webservice",
      method: "get_res_partner",
      args: args,
      kwargs: {},
    };
  
    odoo.execute_kw(params.model, params.method, args, (err, response) => {
      console.log("respuesta", response)
      if (err) {
        console.error("Error en execute_kw:", err);
        alert("Ocurrió un error al cargar los datos");
        call(false, err);
      } else {
        console.log("Datos recibidos:", response);
        localStorage.setItem("students", JSON.stringify(response));
        call(true, response);
      }
    });
  };
  
export const InitializeData = async (client, call) => {
    let finish = false;

    const args = [[
        0,
        { departamento_write_date: null, municipio_write_date: null }
    ]]

    const paramsOdoo = {
        model: "epii.caja.webservice",
        method: "obtenerDatos",
    };
    return client.execute_kw(paramsOdoo.model, paramsOdoo.method, args, async (err, response) => {
        console.log("response obtener datso", err, response);
        if (err) {
            call(2, false, err);
            return false;
        }

        if (response.permiso_vendedorbcan == false) {
            localStorage.setItem("Permission", "" + response.permiso);
            //response['user'] = data;
            call(true, response);

        } else {
            call('vendedor', true);

        }
    })
}
